import { PDFDocumentData } from "@/src/components/pdf-viewer/types";

/**
 * Calculates the most visible PDF page within it's container element.
 * This is used to determine which page is selected when scrolling through
 * the PDF.
 *
 * TODO: If we want to be more efficient, we could start with the current page
 * and scan in the direction of the scroll.
 */
export function calculateMostVisiblePage(container: HTMLElement | null, documentData: PDFDocumentData[]) {
  if (!container) {
    return null;
  }

  const containerRect = container.getBoundingClientRect();
  const containerHeight = containerRect.bottom - containerRect.top;

  let currentDocument: PDFDocumentData | null = null;
  let currentPercentVisible = 0;

  for (let i = 0; i < documentData.length; i++) {
    const document = documentData[i];

    // We should have all canvas refs set at this point so just
    // appeasing TS.
    if (!document.canvasRef.current) {
      return null;
    }

    const canvasRect = document.canvasRef.current?.getBoundingClientRect();
    // Calculate the intersection with the visible container area &
    // get the percentage. We'll use this to determine which page is
    // "most visible".
    const visibleTop = Math.max(containerRect.top, canvasRect.top);
    const visibleBottom = Math.min(containerRect.bottom, canvasRect.bottom);
    const visibleHeight = Math.max(0, visibleBottom - visibleTop);
    const percentVisible = (visibleHeight / containerHeight) * 100;

    if (percentVisible > currentPercentVisible) {
      currentPercentVisible = percentVisible;

      currentDocument = document;
    }

    if (currentPercentVisible !== 0 && percentVisible < currentPercentVisible) {
      return currentDocument;
    }
  }

  return currentDocument;
}
